module.exports = __webpack_public_path__ + "static/media/Converge-Funding.78b056bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/Converge-Funding.jpg
// module id = 437
// module chunks = 0